import PageComponent from '../base/PageComponent';
import 'slick-carousel';

export default class TestimonialCarousel extends PageComponent
{
    init() {
        this.setupCarousel();
    }

    setupCarousel() {
        if (this.getSlides() > 1) {
            this.childElements('.testimonial-item-container').slick({
                slide: '.testimonial-item',
                autoplay: true,
                autoplaySpeed: 5000,
                speed: 1000,
                adaptiveHeight: false,
                dots: false,
                infinite: false,
                prevArrow: "<span class='slick-prev glyphicon glyphicon-chevron-left'></span>",
                nextArrow: "<span class='slick-next glyphicon glyphicon-chevron-right'></span>",
                appendArrows: '.container__testimonial > .container'
            });
        }
    }

    getSlides(){
        return this.childElements('.testimonial-item').length;
    }
}


// WEBPACK FOOTER //
// ./javascript/components/TestimonialCarousel.js